import request from '@/utils/request'

export function getInfo(data) {
  return request({
    url: '/admin/token',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/admin.js